<div [ngClass]="{ 'popup-container': isCellEditorPopup }">
  <app-character-field
    #fieldComponent
    [form-control]="formControl"
    [allowTextArea]="true"
    [displayedInGrid]="true"
    [field]="cellParams.field"
  ></app-character-field>
</div>
